import { apiClientConfiguration } from "app/constants/apiConst";
import {
  DashboardApi,
  DashboardApiV2DashboardTestFlowResultsGetRequest,
  DashboardApiV2DashboardFalsepositiveGetRequest,
  DashboardApiV2DashboardSubstancesGetRequest,
  DashboardApiV2DashboardFlowKeyStatisticsGetRequest,
  DashboardApiV2DashboardTestFlowsPerformedGetRequest,
  DashboardApiV2DashboardFlowMarkersGetRequest,
  DashboardApiV2DashboardFlowInconclusiveGetRequest,
  DashboardApiV2DashboardFlowUserDataGetRequest,
} from "@generated/v2";

const api = new DashboardApi(apiClientConfiguration);

// GET USER DATA
export const dashboardUserdataGet = (
  requestParameters?: DashboardApiV2DashboardFlowUserDataGetRequest,
  options?: any
) => api.v2DashboardFlowUserDataGet(requestParameters, options);

// GET KEY STATISTICS
export const v2DashboardFlowKeyStatisticsGet = (
  requestParameters?: DashboardApiV2DashboardFlowKeyStatisticsGetRequest,
  options?: any
) => api.v2DashboardFlowKeyStatisticsGet(requestParameters, options);

// GET TEST RESULTS
export const dashboardTestFlowResultsGet = (
  requestParameters?: DashboardApiV2DashboardTestFlowResultsGetRequest,
  options?: any
) => api.v2DashboardTestFlowResultsGet(requestParameters, options);

// GET SUBSTANCES
export const dashboardSubstancesGet = (
  requesParameters?: DashboardApiV2DashboardSubstancesGetRequest,
  options?: any
) => api.v2DashboardSubstancesGet(requesParameters, options);

// GET MARKERS FOR MAP
export const dashboardMarkersGet = (
  requestParameters?: DashboardApiV2DashboardFlowMarkersGetRequest,
  options?: any
) => api.v2DashboardFlowMarkersGet(requestParameters, options);

// GET NUMBER OF TESTS PERFORMED
export const dashboardTestsperformedGet = (
  requestParameters?: DashboardApiV2DashboardTestFlowsPerformedGetRequest,
  options?: any
) => api.v2DashboardTestFlowsPerformedGet(requestParameters, options);

// GET OCCURENCE OF FALSE POSITIVES
export const dashboardFalsePositiveGet = (
  requestParameters?: DashboardApiV2DashboardFalsepositiveGetRequest,
  options?: any
) => api.v2DashboardFalsepositiveGet(requestParameters, options);

// GET INCONCLUSIVE STATISTICS
export const dashboardInconclusiveGet = (
  requestParameters?: DashboardApiV2DashboardFlowInconclusiveGetRequest,
  options?: any
) => api.v2DashboardFlowInconclusiveGet(requestParameters, options);
